import companies from "./companies.json";

function showMessage(message, type) {
  const el = document.getElementById("messageContainer");
  el.textContent = message;
  el.className = "message " + (type === "success" ? "success" : "error");

  setTimeout(() => {
    el.className = "message";
    el.textContent = "";
  }, 5000);
}

function getCompanyId() {
  const params = new URLSearchParams(window.location.search);
  return params.get("company_id");
}

function applyCompanyBranding(companyId) {
  const cfg = companies[companyId] || companies.default;

  const root = document.documentElement;
  if (cfg.primaryColor) root.style.setProperty("--primary-color", cfg.primaryColor);
  if (cfg.primaryColorDark) root.style.setProperty("--primary-dark", cfg.primaryColorDark);
  if (cfg.badgeBackground) root.style.setProperty("--badge-bg", cfg.badgeBackground);

  if (cfg.backgroundImage) {
    root.style.setProperty("--bg-image", `url("${cfg.backgroundImage}")`);
    document.body.classList.add("has-bg");
  } else {
    document.body.classList.remove("has-bg");
  }

  const logo = document.getElementById("companyLogo");
  if (logo) logo.src = cfg.logo;

  const heading = document.getElementById("heading");
  if (heading) heading.textContent = cfg.heading;

  const desc = document.getElementById("description");
  if (desc) desc.textContent = cfg.description;

  const label = document.getElementById("buttonLabel");
  if (label) label.textContent = cfg.buttonText;

  const app = document.getElementById("app");
  if (app) app.classList.add("ready");
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => applyCompanyBranding(getCompanyId()));
} else {
  applyCompanyBranding(getCompanyId());
}

Office.onReady((info) => {
  const companyId = getCompanyId();

  if (info.host === Office.HostType.Outlook) {
    console.log("Savvy add-in is ready");

    const button = document.getElementById("reportEmail");

    button.addEventListener("click", () => {
      const item = Office.context.mailbox.item;

      const toRecipients = item.to
        ? item.to.map(r => r.emailAddress)
        : [];

      item.body.getAsync(Office.CoercionType.Html, (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {

          // 👇 Payload for API
          const payload = {
            receiver_email: toRecipients[0] || "",
            sender_email: item.from?.emailAddress || "",
            subject: item.subject || "",
            email_body: result.value
          };

          // ✅ Console log (as you already have)
          console.log("📩 Savvy Reported Email:", payload);

          let url = "https://areeb.zaincloud.com.sa/areeb-backend/public/api/phishing/report";
          if(companyId === 'dev') {
            url = 'https://areeb-dev.savvysaudi.com/api/phishing/report';
          }

          if(companyId === 'srca') {
            url = 'https://srca-ameen.zaincloud.com.sa/areeb-backend/public/api/phishing/report';
          }

          if(companyId === 'sra') {
            url = 'https://elearning.sra.sa/api/phishing/report';
          }
          // 🚀 POST API call (dummy endpoint)
          fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
          })
          .then(response => {
            if (!response.ok) {
              throw new Error("API request failed");
            }
            return response.json();
          })
          .then(data => {
            console.log("✅ API response:", data);
            showMessage("Email reported successfully!", "success");
          })
          .catch(error => {
            console.error("❌ API error:", error);
            showMessage("Failed to report email. Please try again.", "error");
          });

        } else {
          console.error("Failed to get email body", result.error);
        }
      });
    });
  }
});
